
namespace TabAurous.Retail {

    @Serenity.Decorators.registerClass()
    export class PosSalesPromoEditor extends Common.GridEditorBase<PosSalesPromoRow> {
        protected getColumnsKey() { return 'Retail.PosSalesPromo'; }
        protected getDialogType() { return PosSalesPromoDialog; }
        protected getLocalTextPrefix() { return PosSalesPromoRow.localTextPrefix; }

        constructor(container: JQuery) {
            super(container);
            this.slickGrid.setOptions({ rowHeight: 30 });
        }

        public getData(PromoDetails) {
            var tmp = [];
            for (let Detail of PromoDetails) {
                Detail[this.getIdProperty()] = "`" + this.nextId++;
                var x = Detail;
                tmp.push(Detail);
            }
            return tmp;

        }
    }
}